import { Box, Card, CardContent, Grid, Stack } from "@mui/material";
import { Create, required, Toolbar } from "react-admin";
import { SafeUpdateForm } from "@/src/components";
import {
    SectionUserEditAccountInfo, SectionUserEditCredits, SectionUserEditLocation,
    SectionUserEditProfileInfo, SectionUserEditSettings
} from "./Sections";

export const UserCreate = () => (
    <SafeUpdateForm EditOrCreate={(props) =>
        <Create {...props}
        // actions={
        //     <UserEditButtonsToolbar />
        // }
        />
    }>
        <UserFormConent />
    </SafeUpdateForm>
);

export const UserFormConent = () => {
    return (
        <Card>
            <CardContent>
                <Stack>
                    {/* <ReferenceManyField filter={{ moderation: 'accepted' }} source="id"
                        reference="photo" target="user">
                        <SingleFieldList linkType={false}>
                            <ImageFieldExtWithLink source="id" label="Image"
                                getSrc={(photo: any) => photoUrl(photo, 'full')} />
                        </SingleFieldList>
                    </ReferenceManyField> */}

                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                            <Grid container spacing={2}>
                                <Grid size={12}>
                                    <SectionUserEditAccountInfo />

                                </Grid>
                                <Grid size={12}>
                                    <SectionUserEditCredits />
                                </Grid>
                                <Grid size={12}>
                                    <SectionUserEditSettings />
                                </Grid>
                                <Grid size={12}>
                                    <SectionUserEditLocation />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                            <SectionUserEditProfileInfo />
                        </Grid>
                    </Grid>
                </Stack>
            </CardContent>
            <Toolbar />
        </Card>
    )

}



const requiredValidate = [required()];
